/* eslint-disable */
import React, { useState, useContext, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem, Box } from "@mui/material";

//import context
import { GlobalProvider } from "context/GlobalContext";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { groupDetailsHeaderLinks } from "helper/GroupHelper/GroupHelper"; // Changed from EventHelper

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import GroupPartnerHeader from "../Header/GroupPartnerHeader"; // Changed from EventPartnerHeader
import AddNewGroupPartnerModal from "../Modal/AddNewGroupPartnerModal"; // Changed from AddNewPartnerModal
import GroupPartnerDetailsPopup from "../Popup/GroupPartnerDetailsPopup"; // Changed from PartnerDetailsPopup
import { useTranslation } from "react-i18next";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

const GroupPartnerBody = () => {
  const { t, i18n } = useTranslation(); //for translation
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  // State for parent group title
  const [parentGroupTitle, setParentGroupTitle] = useState(""); // Changed from parentEventTitle

  // State for roles and partners
  const [roleList, setRoleList] = useState([]);
  const [partnerList, setPartnerList] = useState([]);

  // Row selection state for table
  const [rowSelection, setRowSelection] = useState({});
  const [selectedPartnerIds, setSelectedPartnerIds] = useState([]);

  // State for selected partner details
  const [partnerId, setPartnerId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);

  // Moderator status
  const [isGroupModerator, setisGroupModerator] = useState(false); // Changed from isEventModerator

  // Member and moderator status
  const [groupMemberStatus, setGroupMemberStatus] = useState(""); // Changed from eventMemberStatus
  const [groupModStatus, setGroupModStatus] = useState(""); // Changed from eventModStatus

  // Loading state for group details
  const [isGroupDetailsLoading, setIsGroupDetailsLoading] = useState(false); // Changed from isEventDetailsLoading

  // Header links state
  const [commonHeaderObject, setCommonHeaderObject] = useState([]); // State for header links

  // Alert states
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Get details of group member
  const getMemberDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_GROUP_MEMBER_DETAILS_BY_QUERY + // Changed API endpoint
        `?token=${token}&groupid=${params.id}`; // Changed eventid to groupid

      const response = await getData(requestUrl);

      console.log("response in member details", response);

      if (response.status) {
        if (response.data) {
          setGroupMemberStatus(response.data.memberstatus);
          setGroupModStatus(response.data.moderatorstatus);

          getAllGroupPartners(true); // Changed getAllEventPartners
        }
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  // Get group details
  const getGroupDetails = async () => {
    setIsGroupDetailsLoading(true); // Changed from setIsEventDetailsLoading
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_GROUP_DETAILS + // Changed API endpoint
        `/${params.id}?token=${token}&modulefrom=common`;

      console.log("url of group details------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response of group details------>", response);

      if (response.status) {
        // Assign title
        response.data?.title && setParentGroupTitle(response.data?.title); // Changed setParentEventTitle

        let isModerator = false;

        // Check if user is moderator or admin
        if (
          response.data.moderator.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN"
        ) {
          isModerator = true;

          getAllGroupPartners(true); // Changed getAllEventPartners
        } else {
          getMemberDetails();
        }

        setisGroupModerator(isModerator); // Changed setisEventModerator

        getAllGroupPartners(); // Changed getAllEventPartners

        // Assign slug and update header links
        setCommonHeaderObject(groupDetailsHeaderLinks(params.id, t));
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsGroupDetailsLoading(false); // Changed from setIsEventDetailsLoading
    }
  };

  // Get all roles for group
  const getAllRoles = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MODULE_ROLES +
        `?token=${token}&slug=MOD_GROUP`;

      const response = await getData(requestUrl);

      if (response.status) {
        setRoleList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Get all group partners
  const getAllGroupPartners = async () => {
    setRowSelection({});
    setSelectedPartnerIds([]);

    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_GROUP_PARTNERS + // Changed API endpoint
        `?token=${token}&group=${params.id}`; // Changed event to group

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setPartnerList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Change status handler for selected partners
  const changeStatusHandler = async () => {
    if (selectedPartnerIds.length > 0) {
      let responseArr = [];

      for (let memberId of selectedPartnerIds) {
        try {
          let groupData = {
            status: "0",
          };
          let requestUrl =
            url.API_BASE_URL +
            url.API_UPDATE_GROUP_MEMBER + // Changed API endpoint
            `/${memberId}` +
            `?token=${token}`;

          const response = await putData(requestUrl, groupData);

          if (response.status) {
            responseArr.push(response.status);
          }
        } catch (error) {
          console.log(error.message);
        }
      }

      getAllGroupPartners(); // Changed getAllEventPartners
    } else {
      setAlertMessage("Please select at least one company for delete");
      setMessageType("error");
      setShowAlert(true);
    }
  };

  // Initialize data on mount
  useEffect(() => {
    if (params.id) {
      const initializeData = async () => {
        await getGroupDetails(); // Changed getEventDetails
        await getAllRoles();

        setIsDataReady(true);
      };

      initializeData();
    }
  }, [params.id]);

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  // Table columns definition
  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        // Action button cell
        Cell: ({ row }) => {
          if (row.original.role === "Moderator") {
            return (
              <button className="action_btn_mui">
                <span className="d-block material-symbols-outlined horz_icon">
                  more_horiz
                </span>
              </button>
            );
          } else {
            return (
              <button
                className="action_btn_mui"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasGroupPartnerDetails" // Changed ID
                aria-controls="offcanvasGroupPartnerDetails" // Changed ID
                onClick={() => {
                  setPartnerId(row.original._id);
                }}
              >
                <span className="d-block material-symbols-outlined horz_icon">
                  more_horiz
                </span>
              </button>
            );
          }
        },
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        accessorKey: "name",
        header: t("Name"),
        size: 250,
        // Name and email cell
        Cell: ({ row }) => (
          <div className="title border-bottom-0">
            <div className="profile d-flex align-items-center gap-2">
              <div
                className="avatar rounded-circle overflow-hidden"
                style={{ width: "35px", height: "35px" }}
              >
                <img
                  src={
                    row.original.image == ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + row.original.image
                  }
                  alt="member"
                  className="w-100 h-100 object-fit-cover object-center"
                />
              </div>
              <div>
                <p className="mb-0">{row.original.name}</p>
                <Link to="#" className="d-block lh-1">
                  {row.original.email}
                </Link>
              </div>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "tagstring",
        header: t("Labels"),
        size: 250,
        // Labels cell
        Cell: ({ row }) => (
          <div className="label border-bottom-0">
            {row.original.tagstring != "" && (
              <ul className="d-flex flex-wrap gap-2 fs-xs">
                {row.original.tagstring.split(" , ").map((tag, index) => {
                  return (
                    <li
                      key={index}
                      className="px-2 py-1 gradient-light rounded-5"
                    >
                      {tag}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        ),
      },
      // {
      //   accessorKey: "role",
      //   header: t("Role"),
      // },
      {
        accessorKey: "moderatorstatus",
        header: t("Status"),
        size: 200,
        // Status cell
        Cell: ({ row }) => (
          <div className="status border-bottom-0">
            <ul className="d-flex flex-wrap gap-3">
              {row.original.moderatorstatus == "" ? (
                <li className="d-flex align-items-center gap-1">
                  <span className="d-block fw-semibold"></span>
                </li>
              ) : (
                <li className="d-flex align-items-center gap-1">
                  <span
                    className={`d-block material-symbols-outlined icon-fill icon-lg  ${
                      row.original.moderatorstatus == "1"
                        ? "text-success"
                        : row.original.moderatorstatus == "0"
                        ? "text-primary"
                        : "text-gray"
                    }`}
                  >
                    check_circle
                  </span>
                  <span className="d-block fw-semibold">Moderator</span>
                </li>
              )}
            </ul>
          </div>
        ),
      },
      {
        accessorKey: "requestdate",
        header: t("Date"),
        size: 200,
      },
    ],
    [partnerList, i18n.language]
  );

  // Initial column order for table
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  // Update selected partner IDs when row selection changes
  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedPartnerIds(selectedIdsArray);
    } else {
      setSelectedPartnerIds([]);
    }
  }, [rowSelection]);

  // Alert close handler
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // Privilege check for rendering
  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_GROUP")
  ) {
    return (
      <div id="content_wrapper">
        <section className="group-details-wrapper bg-white pb-5">
          {/* ---- common header ---- */}
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Partners")}
          />
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            <GroupPartnerHeader
              isGroupModerator={isGroupModerator}
              parentGroupTitle={parentGroupTitle}
              reloadGroupMemberList={getGroupDetails}
              changeStatusHandler={changeStatusHandler}
            />

            {/* Loading skeleton or main table */}
            {!isDataReady || isLoading ? (
              <LoadingSkeleton />
            ) : isGroupModerator ? (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={partnerList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder: initialColumnOrder }}
                  initialState={{
                    rowSelection,
                    columnOrder: initialColumnOrder,
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            ) : (
              <div className="table-wrapper">
                {groupMemberStatus === "1" && groupModStatus === "1" ? (
                  <div className="project-members-container mb-4">
                    <h4 className="fs-sm mb-2 fw-semibold">
                      {t("Group Partners")}
                    </h4>
                    <div className="row">
                      {partnerList.map((member, index) => {
                        return (
                          <div className="col-lg-3 col-sm-6 mb-2" key={index}>
                            <div className="member-box p-3 rounded-5 bg-white d-flex gap-2 align-items-center">
                              <div class="members-pic d-flex align-items-center justify-content-center overflow-hidden body-bg rounded-circle">
                                <img
                                  src={
                                    member.image === ""
                                      ? assetImages.defaultUser
                                      : url.SERVER_URL + member.image
                                  }
                                  alt=""
                                  className="h-100 w-100 object-fit-cover"
                                />
                              </div>
                              <div class="members-info">
                                <h3 class="fs-lg fw-semibold text-black mb-0">
                                  {member.name}
                                </h3>
                                <h5 class="fs-sm mb-0 text-black">
                                  {member.role}
                                </h5>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <AccessDeniedView />
                )}
              </div>
            )}
            {/* ---- list section end---- */}
          </div>
          {/* === popup and modal section === */}
          {/* --- add label modal --- */}
          <AddLabelModal
            moduleName="groupmember"
            afterTagModalClose={getAllGroupPartners}
            selectedIds={selectedPartnerIds}
          />
          {/* --- add new member modal --- */}
          <AddNewGroupPartnerModal
            roleList={roleList}
            afterCloseModalHandler={getAllGroupPartners}
          />
          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedPartnerIds([]);
            }}
            onDelete={changeStatusHandler}
            moduleName={t("Companies")}
          />
          {/* ---- member details popup ---- */}
          <GroupPartnerDetailsPopup
            groupId={params.id}
            roleList={roleList}
            partnerId={partnerId}
            setPartnerId={setPartnerId}
            afterPopupClose={getAllGroupPartners}
          />
          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    // Access denied view for unauthorized users
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default GroupPartnerBody;
